// Largeur de la vue (unités monde) : VIEW_SIZE quand le viseur est carré (portrait) ; plus large quand il occupe tout l'écran
// en paysage (la hauteur reste VIEW_SIZE unités : on voit plus de monde de chaque côté). Tenue à jour par le rendu à chaque
// redimensionnement (ui/renderer.js#resize) ; lue par les dessinateurs du décor et par le jeu (aides, glisser).
import { VIEW_SIZE } from '../config/constants.js';

export const view = { width: VIEW_SIZE };

/** Largeur de la vue pour un cadre de `width` × `height` pixels (la hauteur vaut toujours VIEW_SIZE unités). */
export function viewWidthFor(width, height) {
  return height > 0 && width > 0 ? (VIEW_SIZE * width) / height : VIEW_SIZE;
}
